import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RacersComponent } from './racers/racers.component';
import { TimingComponent } from './timing/timing.component';
import { TrackingComponent } from './tracking/tracking.component';

const routes: Routes = [
    {path: 'tracking', component: TrackingComponent},
    {path: 'racers', component: RacersComponent},
    {path: 'timing', component: TimingComponent},
    // wild card entry drop to Racers Component
    {path: '**', component: TrackingComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
